import type { CityConfig } from "@/pages/city-template/types";

export const fondDuLacConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fond du Lac",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "fond-du-lac",
  route: "/fond-du-lac",
  title: "Emergency & Expedited Passport Services Fond du Lac WI | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fond du Lac, WI — as fast as 24 hours. No Fond du Lac passport agency. Fast Passport Center couriers to the Chicago Passport Agency at 230 S Dearborn St, Suite 380, about 155 miles south via US-41 and I-94. A+ BBB rated. Serving Marian University students, Mercury Marine professionals, and Fond du Lac County families.",
  h1: "Emergency & Expedited Passport Services in Fond du Lac, WI",
  heroSubtitle: "Fond du Lac is a vibrant city at the foot of Lake Winnebago, Wisconsin's largest inland lake, and home to Marian University. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency at 230 S Dearborn St, Suite 380 so you get a new or renewed passport as fast as 24 hours — whether you're a Marian University student preparing for study abroad, a Mercury Marine professional heading to an international boat show, or a Fond du Lac County family planning an overseas vacation.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fond%20du%20Lac%20Wisconsin%20downtown%20with%20Lake%20Winnebago%20shoreline%20and%20the%20historic%20Retlaw%20Hotel%20during%20warm%20summer%20sunset%2C%20small%20midwestern%20city%20architecture%20with%20charming%20Main%20Street%20businesses%2C%20wide%20angle%20professional%20photography%20with%20clean%20composition&width=1800&height=700&seq=fond-du-lac-wi-hero-001&orientation=landscape",
  heroImageAlt: "Fond du Lac Wisconsin downtown with Lake Winnebago shoreline at sunset",
  geoPosition: "43.7730;-88.4470",
  geoPlacename: "Fond du Lac, Wisconsin",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 155 miles from Fond du Lac — about 2 hours 30 minutes via US-41 and I-94",
  },
  nearbyCitiesZips: [
    { name: "Fond du Lac", zips: "54935, 54936, 54937" },
    { name: "Ripon", zips: "54971" },
    { name: "Oakfield", zips: "53065" },
    { name: "North Fond du Lac", zips: "54937" },
    { name: "Waupun", zips: "53963" },
    { name: "Lomira", zips: "53048" },
    { name: "Campbellsport", zips: "53010" },
    { name: "Eden", zips: "53019" },
    { name: "Rosendale", zips: "54974" },
    { name: "Brandon", zips: "53919" },
    { name: "Malone", zips: "53049" },
    { name: "Mount Calvary", zips: "53057" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Chicago Passport Agency — 155 miles from Fond du Lac via US-41" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Lake Winnebago Hub", desc: "Serving Fond du Lac, Ripon, Waupun, and all Fond du Lac County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Fond du Lac case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Chicago IL", route: "/chicago" },
    { name: "Expedited passport in Milwaukee WI", route: "/milwaukee" },
    { name: "Urgent passport in Fond du Lac WI", route: "/fond-du-lac" },
    { name: "Wisconsin passport hub", route: "/wisconsin" },
    { name: "Fast passport in Oshkosh WI", route: "/oshkosh" },
    { name: "Expedited passport in Madison WI", route: "/madison-wi" },
    { name: "Emergency passport in Green Bay WI", route: "/green-bay" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Fond du Lac remotely via secure courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency at 230 S Dearborn St, Suite 380 — approximately 155 miles south. Fond du Lac's location on US-41, a major north-south corridor connecting to I-94, makes overnight courier routing efficient, and our dedicated agents ensure Lake Winnebago region travelers never need to make the 2.5-hour drive to Chicago.",
  fpcOfficeDistance: "Serving all of the Fond du Lac County region",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Fond du Lac, Ripon, Waupun, North Fond du Lac, and the greater Fond du Lac County area. From Marian University students heading abroad to Mercury Marine professionals attending international boat shows, we help Lake Winnebago area travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Fond du Lac and nearby communities including Ripon, Waupun, Oakfield, Lomira, Campbellsport, and the entire Fond du Lac County area.",
  howItWorksIntro: "Most Fond du Lac travelers complete everything online and ship documents overnight. At 155 miles from Chicago, Fast Passport Center provides fast courier turnaround for Fond du Lac County residents — eliminating the 2.5-hour drive to the Chicago Passport Agency.",
  mistakesIntro: "Fond du Lac travelers, including Marian University students studying abroad and Mercury Marine professionals heading to international trade events, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Fond du Lac and Lake Winnebago area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fond du Lac? Here are the most common ones we hear from Lake Winnebago area travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://wisconsindot.gov/Pages/dmv/license-drvs/how-to-apply.aspx",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Marian University students going abroad",
        "Perfect for Mercury Marine international event travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from MKE or ORD",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 230 S Dearborn St, Suite 380",
        "Life-or-death emergencies only",
        "155 miles to Chicago (2 hours 30 minutes via US-41/I-94)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Fond du Lac is 155 miles from the Chicago Passport Agency — our courier service saves Lake Winnebago travelers the drive to the Loop.",
      bullets: ["Fond du Lac County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Fond du Lac County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Fond du Lac adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Fond du Lac and surrounding communities"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Fond du Lac County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Fond du Lac and Lake Winnebago area residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Fond du Lac County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Fond du Lac County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Fond du Lac WI", description: "Urgent passport processing for Fond du Lac, WI travelers via Chicago Passport Agency courier — 155 miles from Fond du Lac." },
    { name: "Passport Renewal Fond du Lac WI", description: "Fast passport renewal for Fond du Lac and Fond du Lac County, Wisconsin residents." },
    { name: "New Passport Fond du Lac WI", description: "First-time passport application assistance for Fond du Lac and Lake Winnebago area residents." },
    { name: "Lost Passport Fond du Lac WI", description: "Passport replacement for lost or stolen passports for Fond du Lac County residents." },
    { name: "Child Passport Fond du Lac WI", description: "Minor passport services for Fond du Lac and Fond du Lac County families." },
    { name: "Name Change Passport Fond du Lac WI", description: "Passport name change service for Fond du Lac, WI residents." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Marian University Student",
      rating: 5,
      text: "I'm a nursing student at Marian University and got accepted to a medical mission trip in Guatemala. Realized 12 days before departure I needed a new passport. Fast Passport Center had it in 4 business days. My agent was so reassuring throughout the whole process.",
      service: "First-Time Passport",
    },
    {
      name: "David K.",
      location: "Mercury Marine Engineer",
      rating: 5,
      text: "Mercury Marine engineer invited to present at an international boat show in Dubai with two weeks notice. My passport had expired three months prior. Fast Passport Center expedited my renewal in 3 business days. The Chicago courier service was flawless.",
      service: "Emergency Renewal",
    },
    {
      name: "Lisa & Tom H.",
      location: "Fond du Lac, WI",
      rating: 5,
      text: "Fond du Lac couple planning a 25th anniversary trip to Ireland. We both needed passport renewals with 5 weeks before departure. Fast Passport Center handled both applications in 7 business days. So much easier than driving to Chicago ourselves.",
      service: "Dual Renewal",
    },
    {
      name: "James R.",
      location: "Ripon, WI",
      rating: 5,
      text: "Ripon resident who realized my passport was missing 9 days before a business trip to London. Fast Passport Center helped with the DS-64 form and got my replacement couriered through Chicago. Had my passport in 5 business days.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "fdl-1",
      name: "Fond du Lac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "99 W 2nd St",
      city: "Fond du Lac",
      state: "WI",
      zip: "54935",
      phone: "(920) 922-3570",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fond du Lac — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Fond du Lac and Fond du Lac County residents. Appointment required. Located downtown near Main Street.",
      icon: "ri-mail-line",
    },
    {
      id: "fdl-2",
      name: "Fond du Lac County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "160 S Macy St",
      city: "Fond du Lac",
      state: "WI",
      zip: "54935",
      phone: "(920) 929-3000",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fond du Lac — Downtown",
      website: "https://www.fdlco.wi.gov",
      websiteLabel: "Fond du Lac County",
      notes: "County clerk passport acceptance services in the City-County Government Center. Convenient downtown location.",
      icon: "ri-government-line",
    },
    {
      id: "fdl-3",
      name: "Ripon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 E Jackson St",
      city: "Ripon",
      state: "WI",
      zip: "54971",
      phone: "(920) 748-2631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ripon — 20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Ripon and western Fond du Lac County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fdl-4",
      name: "Waupun Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12 E Franklin St",
      city: "Waupun",
      state: "WI",
      zip: "53963",
      phone: "(920) 324-3232",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Waupun — 18 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Waupun and Dodge County residents near the Fond du Lac County line.",
      icon: "ri-mail-line",
    },
    {
      id: "fdl-5",
      name: "North Fond du Lac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "325 Garfield St",
      city: "North Fond du Lac",
      state: "WI",
      zip: "54937",
      phone: "(920) 921-7518",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Fond du Lac — 4 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small office serving the northern Fond du Lac area. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
    {
      id: "fdl-6",
      name: "Lomira Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "425 Water St",
      city: "Lomira",
      state: "WI",
      zip: "53048",
      phone: "(920) 269-4300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lomira — 10 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Fond du Lac County and Dodge County border residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "155 miles — 2.5 hour drive on US-41/I-94, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming You Can Walk Into the Chicago Agency Without an Appointment",
      description: "At 155 miles away, Fond du Lac residents are tempted to just 'drive to Chicago and get it done.' But the Chicago Passport Agency at 230 S Dearborn St, Suite 380 requires pre-scheduled NPIC appointments — no walk-ins. Appointments often fill 2–3 weeks in advance, especially during spring break and summer travel seasons.",
    },
    {
      icon: "ri-calendar-line",
      title: "Marian University Students Waiting Until Finals Week",
      description: "Marian University students accepted to study abroad programs often wait until finals week to handle passport applications — right when the Fond du Lac Post Office and County Clerk are busiest. Summer study abroad planning should start passport applications in March, not late April or May.",
    },
    {
      icon: "ri-ship-line",
      title: "Mercury Marine Employees Confusing Business Travel With Leisure Travel Timing",
      description: "Mercury Marine professionals attending international boat shows like METSTRADE in Amsterdam or the Dubai International Boat Show often underestimate passport processing times for last-minute business trips. Unlike domestic conferences, international trade shows require both a valid passport and, in some cases, a business visa.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking International Flights",
      description: "Lake Winnebago area travelers often book international flights months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-image-line",
      title: "Using Driver's License Photos as Passport Photos",
      description: "Fond du Lac residents sometimes try to use Wisconsin driver's license photos or self-taken phone photos for passport applications. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses. Only professional passport photo services meet U.S. Department of State standards.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Fond du Lac residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Fond du Lac, Ripon, or Waupun." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Chicago Passport Agency — 155 miles south via US-41/I-94." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fond du Lac area address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Fond du Lac from the Chicago passport agency?",
      a: "Fond du Lac is approximately 155 miles from the Chicago Passport Agency at 230 S Dearborn St, Suite 380 in the Chicago Loop — about a 2 hour 30 minute drive south via US-41 and I-94. However, the Chicago agency requires pre-scheduled appointments and does not accept walk-ins.",
    },
    {
      q: "Does Fond du Lac, WI have its own passport agency?",
      a: "No. Fond du Lac does not have a passport agency. The closest passport agency is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, about 155 miles south. Fond du Lac has passport acceptance facilities — the Fond du Lac Post Office at 99 W 2nd St and the Fond du Lac County Clerk's office — which can accept your DS-11 application but cannot process or expedite it.",
    },
    {
      q: "I'm a Marian University student — how fast can I get a passport for study abroad?",
      a: "Marian University students heading to study abroad programs in Europe, Asia, or South America are frequent clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. We recommend starting the process at least 2–3 months before your program start date to allow time for student visa processing.",
    },
    {
      q: "Where do Fond du Lac travelers typically fly internationally?",
      a: "Fond du Lac travelers typically fly from Milwaukee Mitchell International Airport (MKE, about 70 miles south) or Chicago O'Hare International Airport (ORD, about 155 miles south). MKE offers limited international service while ORD provides extensive global routes. Many Fond du Lac residents also use Appleton International Airport (ATW, about 40 miles north) for domestic connecting flights.",
    },
    {
      q: "How fast can I get an emergency passport in Fond du Lac?",
      a: "Emergency processing is typically 24–48 hours for Fond du Lac residents. Given Fond du Lac's location directly on US-41, overnight courier routing to Chicago is efficient. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Fond du Lac?",
      a: "Walgreens at 333 N Peters Ave and CVS Pharmacy at 485 N Rolling Meadows Dr in Fond du Lac offer passport photo services. The UPS Store at 835 S Main St also provides photos. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "Can the Fond du Lac County Clerk's office process my passport?",
      a: "Yes. The Fond du Lac County Clerk's office at 160 S Macy St in the City-County Government Center accepts passport applications as a passport acceptance facility. They can accept DS-11 applications and verify your documents. Call (920) 929-3000 before visiting to confirm current passport service hours.",
    },
    {
      q: "How do I renew my passport in Fond du Lac?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Fond du Lac Post Office or County Clerk for an in-person DS-11 application.",
    },
    {
      q: "Does the Fond du Lac Post Office take walk-in passport appointments?",
      a: "The Fond du Lac Post Office at 99 W 2nd St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (920) 922-3570 to schedule. The post office is often busiest during lunch hours and late afternoons.",
    },
    {
      q: "Can Fast Passport Center help Ripon and Waupun residents too?",
      a: "Absolutely. We serve all of Fond du Lac County and surrounding communities including Ripon, Waupun, North Fond du Lac, Oakfield, Lomira, Campbellsport, and Eden. Residents of surrounding communities never need to drive to Fond du Lac or Chicago for service.",
    },
    {
      q: "I work at Mercury Marine and need a passport for an international boat show — what's the timeline?",
      a: "Mercury Marine professionals heading to international trade shows should start passport preparation 3–4 months before travel. Many international events require both a valid passport and a business visa. Fast Passport Center processes passports in 2–9 business days, but allow extra time for visa processing after you receive your passport.",
    },
    {
      q: "Is the Fond du Lac County Clerk faster than the Post Office for passport applications?",
      a: "Both the Fond du Lac Post Office and the County Clerk's office serve as passport acceptance facilities with similar processing capabilities. The County Clerk's office at 160 S Macy St often has shorter wait times and more flexible hours (8:00 AM–4:30 PM vs. the post office's 9:00 AM–4:00 PM). However, neither facility can expedite processing — that's where Fast Passport Center's courier service comes in.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Fond du Lac", address: "333 N Peters Ave, Fond du Lac, WI 54935", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Fond du Lac", address: "485 N Rolling Meadows Dr, Fond du Lac, WI 54937", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Fond du Lac", address: "835 S Main St, Fond du Lac, WI 54935", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "Walmart Photo — Fond du Lac", address: "377 N Rolling Meadows Dr, Fond du Lac, WI 54937", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/store/finder" },
    { name: "Walgreens — Waupun", address: "1 W Main St, Waupun, WI 53963", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Oshkosh", address: "1725 W 9th Ave, Oshkosh, WI 54904", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator" },
  ],
  dmvLocations: [
    { name: "WI DMV — Fond du Lac", address: "51 E 1st St, Fond du Lac, WI 54935", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Full-service DMV center for Fond du Lac County. REAL ID, driver's license, and state ID services. Convenient downtown location.", featured: true },
    { name: "WI DMV — Oshkosh", address: "1900 Omro Rd, Oshkosh, WI 54904", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Serves Winnebago County and northern Fond du Lac County residents. About 25 miles north of Fond du Lac.", featured: false },
    { name: "WI DMV — West Bend", address: "801 W Paradise Dr, West Bend, WI 53095", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Serves Washington County. About 35 miles south of Fond du Lac.", featured: false },
  ],
  airports: [
    {
      code: "ATW",
      name: "Appleton International Airport",
      distance: "40 miles north of Fond du Lac",
      address: "W6390 Challenger Dr, Appleton, WI 54914",
      note: "Closest commercial airport to Fond du Lac. Domestic routes via major carriers with connecting international service. About 45 minutes north via US-41.",
      flightUrl: "https://atwairport.com/",
      flightLabel: "ATW Airport",
      featured: true,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "70 miles south of Fond du Lac",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Wisconsin's busiest airport with domestic routes and some international service. About 1 hour 15 minutes south via US-41 and I-41.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "155 miles south of Fond du Lac",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway with extensive global routes. About 2 hours 30 minutes south. Co-located near Chicago Passport Agency.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
    {
      code: "GRB",
      name: "Green Bay Austin Straubel International Airport",
      distance: "70 miles north of Fond du Lac",
      address: "2077 Airport Dr, Green Bay, WI 54313",
      note: "Regional airport serving northeastern Wisconsin. Domestic routes with connecting international service. About 1 hour 15 minutes north.",
      flightUrl: "https://www.flygrb.com/",
      flightLabel: "GRB Airport",
      featured: false,
    },
  ],
};